import { NgModule } from '@angular/core';
import { SearchHighlightPipe } from './search-highlight.pipe';
/**
 * A module containing objects associated with the search highlight pipe
 */
var SearchHighlightPipeModule = /** @class */ (function () {
    function SearchHighlightPipeModule() {
    }
    SearchHighlightPipeModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SearchHighlightPipe
                    ],
                    exports: [
                        SearchHighlightPipe
                    ]
                },] },
    ];
    /** @nocollapse */
    SearchHighlightPipeModule.ctorParameters = function () { return []; };
    return SearchHighlightPipeModule;
}());
export { SearchHighlightPipeModule };
//# sourceMappingURL=search-highlight.pipe.module.js.map